import React, { Component } from 'react';
import * as $ from 'jquery';
import axios from 'axios';
import moment from 'moment-timezone';
import { MENU } from '../../dashboard/Sidebar.js';
import { translate } from 'react-i18next';
import { ERRORS } from '../../App.js';
import { Redirect, withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import Footer from '../Footer.js';
import Navbar from '../Navbar.js';
import InvoicePayment from '../../dashboard/invoices/payment/ProsaPaymentContainer.js';


class ExternalProsaAmexContainer extends Component {

  constructor(props) {
    super(props);
  }

  renderInvoicePayment = () => {
      return(
        <InvoicePayment
          getTokenId={this.props.getTokenId}
          getTokenSession={()=> {""}}
          folio_externo = {this.props.match.params.external_token}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          user={null} />
      );
    
  }

  
  render() {
    const { t } = this.props;

    return(
      <div>
        {this.renderNavbar()}
        <h2 className="page-header" style={{paddingTop: "3%",paddingLeft: "5%"}}>{t('dashboard.invoices.heading_pending')}</h2>
        <div style={{paddingLeft: "5%",paddingRight: "5%"}}>
        {this.renderInvoicePayment()}
        </div>
        {this.renderFooter()}
      </div>
    );
  }

  renderFooter = () => {
      return(
          <Footer />
      );
  }

  renderNavbar = () => {
      return(
          <Navbar
          handleLanguageChange={this.props.handleLanguageChange}
          lang={this.props.lang} />
      );
  }


}


export default compose(
  translate('common'),
  withRouter
)(ExternalProsaAmexContainer);



// WEBPACK FOOTER //
// ./src/guest/payment/ExternalProsaAmexContainer.js